import React from 'react'
import classNames from 'classnames'
import UnderlinedText from '#src/components/UnderlinedText'
import ArrowRight from './arrow-right.svg'
import capitalize from 'lodash/capitalize'
import styles from './styles.css'

interface SectionHeaderProps {
  header: string
  mobileSubHeader?: string
  withBorder?: boolean
  className?: string
}

const SectionHeader: React.SFC<SectionHeaderProps> = ({
  header,
  mobileSubHeader,
  className,
  withBorder
}) => {
  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(
          styles.mobileHeader,
          {
            [styles.withBorder]: withBorder
          },
          className
        )}
      >
        <UnderlinedText thickness={4} underlineColor="#e04f00">
          {header}
        </UnderlinedText>
        {mobileSubHeader && (
          <span className={styles.mobileSubHeader}>
            {mobileSubHeader} <ArrowRight className={styles.mobileSubHeaderIcon} />
          </span>
        )}
      </div>
      <div className={classNames(styles.desktopHeader, className)}>{capitalize(header)}</div>
    </div>
  )
}

export default SectionHeader
